import { useEffect, useState } from "react";

const nextWindow = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth() + 1, 1, 0, 0, 0);
};

export default function VipCountdown() {
  const [left, setLeft] = useState({ d: 0, h: 0, m: 0, s: 0 });

  useEffect(() => {
    const tick = () => {
      const diff = Math.max(0, nextWindow().getTime() - Date.now());
      setLeft({
        d: Math.floor(diff / 86400000),
        h: Math.floor(diff / 3600000) % 24,
        m: Math.floor(diff / 60000) % 60,
        s: Math.floor(diff / 1000) % 60,
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  const cells = [["Days", left.d], ["Hours", left.h], ["Min", left.m], ["Sec", left.s]];
  return (
    <div className="flex flex-wrap gap-3" data-testid="vip-countdown">
      {cells.map(([label, v]) => (
        <div key={label} className="bg-white/10 border border-white/15 rounded-2xl px-4 py-3 text-center min-w-[72px] backdrop-blur">
          <p className="font-mono2 text-2xl md:text-3xl text-[#D9B84A] leading-none" data-testid={`countdown-${label.toLowerCase()}`}>
            {String(v).padStart(2, "0")}
          </p>
          <p className="font-mono2 text-[9px] uppercase tracking-[0.2em] text-white/60 mt-2">{label}</p>
        </div>
      ))}
    </div>
  );
}
